// shopping types
export default {
  GET_FOODMAKER: 'GET_FOODMAKER',
  GET_FOODMAKER_BY_ID: 'GET_FOODMAKER_BY_ID',
};
